import { DataSource, ExcludableTextbox, Layout, Switch, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutTimecardHistoryReport extends Layout {
    excludabletextboxDivisions: ExcludableTextbox;
    excludabletextboxJobClasses: ExcludableTextbox;
    excludabletextboxPayees: ExcludableTextbox;
    excludabletextboxTerminals: ExcludableTextbox;
    sourceTimecardHistory: DataSource;
    switchReportType: Switch;
    textboxCheckDateRange: Textbox;
    textboxSort: Textbox;
}
